export interface ProductImages {
    facets: string[];
    presets: string[];
    urlPattern: string;
}

export enum ImageSizes {
    XXL = "xxl",
    XL = "xl",
    L = "l",
    ZOOM = "zoom",
    S = "s"
};

export enum MediaSizes {
    XXL = "(min-width:501px)",
    XL = "(min-width:301px) and (max-width:500px)",
    L = "(max-width:300px)",
};

export enum LoadingMechanism {
    LAZY = "lazy",
    EAGER = "eager",
};

